export { SpecialOffersCarousel } from './special-offers-carousel';
